import { useMemo } from 'react';
import {
  mapFromCompanyToAnnualRevenueEarnings,
  mapToAnnualRevenueEarnings,
} from '../../components/TimeseriesPlot/mappers/timeseriesMap';
import { getJsonField } from '@/utilities/object';
import isNumber from 'lodash/isNumber';
import type { NarrativeValuation } from '../useNarrativeById';
import type { NarrativeValuatorCompany } from '../narrativeValuatorCompanyFragment';
import type { Narrative } from '../useNarrative';

type FiscalData =
  | NarrativeValuation['fiscalData']
  | Narrative['valuation']['fiscalData'];

export const usePastAnnualRevenueEarnings = ({
  company,
  fiscalData,
}: {
  company: NarrativeValuatorCompany;
  fiscalData?: FiscalData;
}) => {
  const pastAnnualRevenueEarnings = useMemo(() => {
    if (!company || !company.analysisPast)
      return {
        mostRecentReportedDate: '',
        yearlyTimeSeries: {},
      };

    const hasFiscalData =
      (!!fiscalData && !!fiscalData.mostRecentReportedDate) ||
      (!!fiscalData &&
        !!fiscalData.yearlyTimeSeries &&
        fiscalData.yearlyTimeSeries.length > 0);

    return hasFiscalData
      ? mapToAnnualRevenueEarnings(
          fiscalData as NarrativeValuation['fiscalData']
        )
      : mapFromCompanyToAnnualRevenueEarnings(
          company.analysisPast,
          getJsonField<number>(
            company.data.currencyInfo,
            'reporting_unit',
            isNumber
          ) ?? 1
        );
  }, [fiscalData, company]);

  return pastAnnualRevenueEarnings;
};
